import { Component, OnInit, Input } from "@angular/core";
import { PageEvent, MatTableDataSource } from "@angular/material";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

import { UsersService } from "@service/admin/users.service";
import { Paginate } from "@model/admin/paginate";
import { UserAccess } from "@model/admin/user-access";
import { User } from "@model/User";

@Component({
  selector: "app-modal-users-access",
  templateUrl: "./modal-users-access.component.html",
  styleUrls: ["./modal-users-access.component.scss"],
})
export class ModalUsersAccessComponent implements OnInit {
  @Input() public user: User;

  public displayedColumns: string[] = ["created_at"];
  public pageEvent: PageEvent;
  public page: Paginate<UserAccess> = {
    per_page: 5,
    current_page: 0,
    totalElements: 0,
  } as Paginate<UserAccess>;
  public dataSource = new MatTableDataSource<any>();
  public pageSizeOptions: number[] = [5, 10, 20];

  constructor(
    public activeModal: NgbActiveModal,
    public usersService: UsersService
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.getUsersAccess({
        previousPageIndex: 0,
        pageIndex: this.page.current_page,
        pageSize: this.page.per_page,
        length: this.page.totalElements,
      });
    }, 0);
  }

  getUsersAccess(event?: PageEvent): PageEvent {
    this.usersService
      .getAccess(this.user.id, event.pageSize, event.pageIndex + 1)
      .subscribe((response: Paginate<UserAccess>) => {
        this.page = {
          ...this.page,
          totalPages: response.totalPages,
          totalElements: response.totalElements,
        };
        this.dataSource.data = response.data;
      });
    return event;
  }
}
